import { FaCogs, FaFireAlt, FaTree, FaHandshake } from 'react-icons/fa';

const features = [
    {
        id: 1,
        icon: <FaCogs />, // Tech Excellence icon
        title: 'Tech Excellence',
        description: 'Utilizing cutting-edge technology for enhanced operations.',
    },
    {
        id: 2,
        icon: <FaFireAlt />, // Fire Prevention icon
        title: 'Fire Prevention',
        description: 'Implementing proactive measures and community programs to prevent fires.',
    },
    {
        id: 3,
        icon: <FaTree />, // Green Practices icon
        title: 'Green Practices',
        description: 'Minimizing environmental impact with sustainable practices.',
    },
    {
        id: 4,
        icon: <FaHandshake />, // Safety Collaboration icon
        title: 'Safety Collaboration',
        description: 'Working with the public and agencies for community safety.',
    },
];

export default features;